export const PENDING = 0;
export const MANAGER_APPROVE = 1;
export const MANAGER_REJECT = 2;
export const PAYROLL_APPROVE = 3;
export const PAYROLL_REJECTED = 4;
export const CANCEL_PENDING = 5;
export const CANCEL_APPROVED = 6;
export const CANCEL_REJECTED = 7;

export const LeaveStatusText = {
  [PENDING]: "Pending",
  [MANAGER_APPROVE]: "Pending",
  [MANAGER_REJECT]: "Rejected",
  [PAYROLL_APPROVE]: "Approve",
  [PAYROLL_REJECTED]: "Rejected",
  [CANCEL_PENDING]: "Cancel Requested",
  [CANCEL_APPROVED]: "Cancel Approved",
  [CANCEL_REJECTED]: "Cancel Rejected",
};
